<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Messenger" class="d-icon d-icon--messenger" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 2.86c-5.281 0-9.375 3.868-9.375 9.093 0 2.733 1.12 5.095 2.944 6.726a.75.75 0 0 1 .252.535l.051 1.668a.75.75 0 0 0 1.053.663l1.86-.822a.748.748 0 0 1 .501-.037c.855.236 1.765.36 2.714.36 5.281 0 9.375-3.868 9.375-9.093S17.281 2.86 12 2.86Z" :fill="`url(#${uniqueID}a)`"/><path fill-rule="evenodd" clip-rule="evenodd" d="m6.37 14.613 2.754-4.37a1.406 1.406 0 0 1 2.034-.375l2.19 1.643c.2.15.477.15.678-.002l2.958-2.245c.394-.3.91.173.646.592l-2.754 4.37a1.406 1.406 0 0 1-2.034.374l-2.19-1.642a.562.562 0 0 0-.678.002l-2.958 2.245c-.395.3-.91-.173-.646-.592Z" fill="#fff"/><defs><radialGradient :id="`${uniqueID}a`" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(6.234 21.51) scale(20.4299)"><stop stop-color="#09F"/><stop offset=".61" stop-color="#A033FF"/><stop offset=".935" stop-color="#FF5280"/><stop offset="1" stop-color="#FF7061"/></radialGradient></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconMessenger',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
